import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import moment from "moment";
import PhoneInput from "react-phone-input-2";
import es from "react-phone-input-2/lang/es.json";
import "react-phone-input-2/lib/style.css";
import Get from "../../api/Get";
import {
  COUNTRY_ACTIVE_ALL,
  GET_EPS,
  GET_LOCALIDADES,
  GET_OCUPACION,
  GET_PROPERTY_TYPES,
  GET_ROAD_TYPE,
  MUNICIPIO_LIST,
  PACIENTE_BUSCAR,
  PARTNER_GET_ACTIVE_SIN_TOKEN,
  STATES_LIST,
  TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
} from "../../api/Routes";
import { getTokenExternal } from "../../utils/getTokenExternal";
import Select from "react-select";
import Post from "../../api/Post";
import ModalText from "../ModalText";
import LoadingList from "../../loader/LoadingList";
import SimpleLoad from "../../loader/SimpleLoad";
import { checkFieldValidation } from "../../utils/checkFieldValidation";

function StepOneCLB({
  t,
  next,
  initialData,
  phoneNumber,
  tipoSangre,
  setPhoneNumber,
  setTipoSangre,
  paciente,
  setShowModalError,
  setErrorServer,
  notEdit,
  source,
  setInitialData,
  phoneNumber2,
  setPhoneNumber2,
  fieldSettings,
  configuration,
}) {
  const [stateByDefault, setStateByDefault] = useState(initialData);
  const [gender, setGender] = useState(initialData.gender);
  const [dateOfBirthday, setDateOfBirthday] = useState(
    initialData.dateOfBirthday
      ? new Date(moment(initialData.dateOfBirthday, "DD-MM-YYYY"))
      : null
  );
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [estadoDefault, setEstadoDefault] = useState(
    initialData.state_name
      ? { label: initialData.state_name, value: initialData.state }
      : paciente
      ? { label: paciente.state?.name, value: paciente.state?.id }
      : null
  );
  const [municipioDefault, setMunicipioDefault] = useState(
    initialData.municipio_name
      ? { label: initialData.municipio_name, value: initialData.municipio }
      : paciente
      ? { label: paciente.municipio?.dsMunDel, value: paciente.municipio?.id }
      : null
  );
  const [locationDefault, setLocationDefault] = useState(
    initialData.location_name
      ? { label: initialData.location_name, value: initialData.location }
      : paciente
      ? {
          label: paciente.localidad?.nombreLocalidad,
          value: paciente.localidad?.id,
        }
      : null
  );
  //const [ocupacionDefault, setOcupacionDefault]= useState(paciente ? {label: paciente.ocupacion?.nombreOcupacion, value: paciente.ocupacion?.id} : initialData.ocupacion ? {label: initialData.ocupacion_name, value: initialData.ocupacion} : null)
  const [ocupacionDefault, setOcupacionDefault] = useState(
    initialData.ocupacion_name
      ? { label: initialData.ocupacion_name, value: initialData.ocupacion }
      : paciente
      ? {
          label: paciente.ocupacion?.nombreOcupacion,
          value: paciente.ocupacion?.id,
        }
      : null
  );
  //console.log(initialData.ocupacion_name)
  //console.log(paciente.ocupacion)
  const [isEpsDefault, setIsEpsDefault] = useState(false);
  const handleSubmit = (values) => {
    next(values);
  };
  const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([]);
  const [estadoOpt, setEstadoOpt] = useState([]);
  const [municipioOpt, setMunicipioOpt] = useState([]);
  const [countryOpt, setCountryOpt] = useState([]);
  const [countryBirthOpt, setCountryBirthOpt] = useState([]);
  const [localidadesOpt, setLocalidadesOpt] = useState([]);
  const [ocupacionOpt, setOcupacionOpt] = useState([]);
  const [paisDefault, setPaisDefault] = useState(
    initialData.country_name
      ? { label: initialData.country_name, value: initialData.country }
      : paciente
      ? { label: paciente.country?.name, value: paciente.country?.id }
      : null
  );
  const [paisNacimientoDefault, setPaisNacimientoDefault] = useState(
    initialData.countryBirth_name
      ? {
          label: initialData.countryBirth_name,
          value: initialData.countryBirth,
        }
      : paciente
      ? { label: paciente.countryBirth?.name, value: paciente.countryBirth?.id }
      : null
  );

  const [tipoPacientes, setTipoPacientes] = useState([]);

  //aditional directions
  const [roadTypes, setRoadTypes] = useState([]);
  const [roadTypesDefault, setRoadTypesDefault] = useState(
    initialData.colombusAddress?.roadType_name
      ? {
          label: initialData.roadType_name,
          value: initialData.colombusAddress?.roadType?.id,
        }
      : paciente
      ? {
          label: paciente.colombusAddress?.roadType?.name,
          value: paciente.colombusAddress?.roadType?.id,
        }
      : null
  );
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [propertyTypesDefault, setPropertyTypesDefault] = useState(
    paciente
      ? {
          label: paciente.colombusAddress?.propertyType?.name,
          value: paciente.colombusAddress?.propertyType?.id,
        }
      : initialData.colombusAddress?.propertyType
      ? {
          label: initialData.propertyType_name,
          value: initialData.colombusAddress?.propertyType?.id,
        }
      : null
  );
  const [propertyTypesAdicionalDefault, setPropertyTypesAdicionalDefault] =
    useState(
      paciente
        ? {
            label: paciente.colombusAddress?.propertyTypeAdditional?.name,
            value: paciente.colombusAddress?.propertyTypeAdditional?.id,
          }
        : initialData.colombusAddress?.propertyTypeAdditional
        ? {
            label: initialData.propertyTypeAdditional_name,
            value: initialData.colombusAddress?.propertyTypeAdditional?.id,
          }
        : null
    );

  const [idTipoDocumento, setIdTipoDocumento] = useState(null);

  //disabled input hasta q se haga la peticion
  const [disabledDocument, setDisabledDocument] = useState(true);
  const [disabledInputs, setDisabledInputs] = useState(true);
  const [loadPaciente, setLoadPaciente] = useState(false);
  const [modalEncontro, setModalEncontro] = useState(false);
  const [isBusandoPaciente, setIsBusandoPaciente] = useState(false);
  const enableFieldConsulta =
    source === "autoagendamientovardi" ||
    source === "autoagendamientoappallianz" ||
    source === "flujoallianz" ||
    source === "autoagendamientonuevoeps"
      ? false
      : true;
  //const [epsDefault, setEpsDefault] = useState((paciente && paciente.eps)  ? {label: paciente.eps?.nombreEps, value: paciente.eps?.id}  : initialData.eps ? {label: `${initialData.eps?.nombreEps}`, value: initialData.eps?.id} : null)
  //console.log(initialData.eps)
  const [epsDefault, setEpsDefault] = useState(
    initialData.eps
      ? { label: `${initialData.eps?.nombreEps}`, value: initialData.eps?.id }
      : paciente && paciente.eps
      ? { label: paciente.eps?.nombreEps, value: paciente.eps?.id }
      : null
  );
  const [epsOpt, setEpsOpt] = useState([]);

  useEffect(() => {
    let mounted = true;
    Get({ url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true })
      .then((response) => {
        setTipoDocumentoOpt(response.data);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });

    Get({ url: COUNTRY_ACTIVE_ALL, noToken: true })
      .then((response) => {
        //console.log(response)
        setCountryOpt(
          response.data.data.response.map((el) => ({
            label: el.name,
            value: el.id,
          }))
        );
        setCountryBirthOpt(
          response.data.data.response.map((el) => ({
            label: el.name,
            value: el.id,
          }))
        );
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({
      url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${initialData.account.id}`,
      noToken: true,
    })
      .then((response) => {
        setTipoPacientes(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    //direccion de clb
    getTokenExternal(
      initialData.company
        ? initialData.company
        : initialData.account.partner.company
    ).then((response) => {
      if (mounted) {
        Get({ url: GET_ROAD_TYPE, access_token: response.data.access_token })
          .then((response) => {
            setRoadTypes(response.data.data.response);
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
        Get({
          url: GET_PROPERTY_TYPES,
          access_token: response.data.access_token,
        })
          .then((response) => {
            setPropertyTypes(response.data.data.response);
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });

        //localidades
        Get({ url: GET_LOCALIDADES, access_token: response.data.access_token })
          .then((response) => {
            if (response.data.state) {
              setLocalidadesOpt(
                response.data.data.response.map((el) => ({
                  label: el.nombreLocalidad,
                  value: el.id,
                }))
              );
            }
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
        //ocupacion
        Get({ url: GET_OCUPACION, access_token: response.data.access_token })
          .then((response) => {
            if (response.data.state) {
              setOcupacionOpt(
                response.data.data.response.map((el) => ({
                  label: el.nombreOcupacion,
                  value: el.id,
                }))
              );
            }
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
        //eps
        Get({ url: GET_EPS, access_token: response.data.access_token })
          .then((response) => {
            //console.log(response)
            if (response.data.state) {
              setEpsOpt(
                response.data.data.response.map((el) => ({
                  label: el.nombreEps,
                  value: el.id,
                }))
              );
            }
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
      }
    });
  }, []);

  const [textoEncontro, setTextoEncontro] = useState(
    "Sr(a) usuario por favor verifique la información del formulario, si requiere actualizar algún campo edítelo con la información correcta antes de continuar"
  );
  useEffect(() => {
    if (source === "flujoallianz" || source === "autoagendamientoappallianz") {
      setTextoEncontro(
        "Por favor verifica la información del formulario, si necesitas actualizar algún campo, puedes editarlo antes de continuar."
      );
    }
  }, [source]);

  //si cambia el pais
  const [idCountry, setIdCountry] = useState(initialData.country);
  useEffect(() => {
    if (idCountry) {
      Get({ url: `${STATES_LIST}/${idCountry}`, noToken: true })
        .then((response) => {
          //console.log(response)
          setEstadoOpt(
            response.data.data.response.map((el) => ({
              label: el.name,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setEstadoOpt([]);
        });
    } else {
      setEstadoOpt([]);
    }
  }, [idCountry]);

  //si cambia el estado
  const [idEstado, setIdEstado] = useState(initialData.state);
  useEffect(() => {
    if (idEstado) {
      Get({ url: `${MUNICIPIO_LIST}/${idEstado}`, noToken: true })
        .then((response) => {
          //console.log(response)
          setMunicipioOpt(
            response.data.data.response.map((el) => ({
              label: el.dsMunDel,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setMunicipioOpt([]);
        });
    } else {
      setMunicipioOpt([]);
    }
  }, [idEstado]);

  const getTipoDocumento = (value) => {
    let arr = tipoDocumentoOpt
      .filter((el) => el.code === "AS" || el.code === "MS")
      .map((e) => e.id);
    return arr.includes(parseInt(value));
  };
  const [hasLength, setHasLength] = useState(10);
  const getLengthDN = (code) => {
    switch (code.toUpperCase()) {
      case "CE":
        return 12;
      case "CD":
      case "PA":
      case "SC":
        return 16;
      case "PE":
        return 15;
      case "RC":
      case "TI":
        return 11;
      case "CN":
        return 9;
      case "MS":
        return 12;
      default:
        return 10;
    }
  };

  const shemaValidateStepOne = Yup.object().shape({
    name: Yup.string().required(t("Camporequerido")),
    lastName: Yup.string().required(t("Camporequerido")),
    gender: checkFieldValidation("gender", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    dateOfBirthday: Yup.string().required(t("Camporequerido")),
    phoneNumber: Yup.string().required(t("Camporequerido")),
    phoneNumber2: Yup.string().required(t("Camporequerido")),
    email: Yup.string()
      .email(t("Correoinvalido"))
      .matches(/^(?!prueba@prueba.com\b)/i, "Este correo no se puede usar")
      .required(t("Camporequerido")),
    identityDocumentType: Yup.string().required(t("Camporequerido")),
    documentNumber: Yup.string().when("identityDocumentType", {
      is: (value) => getTipoDocumento(value),
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string()
        .required(t("Camporequerido"))
        .min(5, `Debe tener una longitud mínima de 5 caracteres`)
        .max(
          hasLength,
          `Debe tener una longitud máxima de ${hasLength} caracteres`
        ),
    }),
    country: checkFieldValidation("country", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    countryBirth: checkFieldValidation("countryBirth", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    //municipio: Yup.string().required(t('Camporequerido')),
    location: Yup.string().when("municipio", {
      is: (value) =>
        value !== "2633" &&
        !checkFieldValidation("localidad", fieldSettings)?.required,
      then: Yup.string().notRequired(),
      otherwise: Yup.string().required(t("Camporequerido")),
    }),
    //state: Yup.string().required(t('Camporequerido')),
    ocupacion: checkFieldValidation("ocupacion", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    nationality: checkFieldValidation("nationality", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    bloodType: checkFieldValidation("bloodType", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    peso: checkFieldValidation("peso", fieldSettings)?.required
      ? Yup.number().required(t("Camporequerido")).positive(t("mayor_a_cero"))
      : Yup.number().positive(t("mayor_a_cero")),
    talla: checkFieldValidation("talla", fieldSettings)?.required
      ? Yup.number().required(t("Camporequerido")).positive(t("mayor_a_cero"))
      : Yup.number().positive(t("mayor_a_cero")),
    sintomas: Yup.string().required(t("Camporequerido")),
    aceptarTerminos: Yup.bool().oneOf(
      [true],
      t("aceptar_terminos_condiciones")
    ),
    patientRelationship: checkFieldValidation(
      "patientRelationship",
      fieldSettings
    )?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    colombusAddress: Yup.object().shape({
      //roadType: Yup.string().required(t('Camporequerido')),
      //streetField1: Yup.string().required(t('Camporequerido')),
      //streetField2: Yup.string().required(t('Camporequerido')),
      //streetField3: Yup.string().required(t('Camporequerido')),
      //propertyTypeAdditional: checkFieldValidation("propertyTypeAdditional", fieldSettings)?.required ? Yup.string().required(t('Camporequerido')) : Yup.string().notRequired(),
      //propertyNumber: checkFieldValidation("propertyTypeAdditional", fieldSettings)?.required ? Yup.string().required(t('Camporequerido')) : Yup.string().notRequired(),
      //propertyType: checkFieldValidation("propertyType", fieldSettings)?.required ? Yup.string().required(t('Camporequerido')) : Yup.string().notRequired(),
      //unitNumber: checkFieldValidation("propertyType", fieldSettings)?.required ? Yup.string().required(t('Camporequerido')) : Yup.string().notRequired(),
    }),
    eps: Yup.object().when("account", {
      is: (value) =>
        value &&
        value.id === 144 &&
        !checkFieldValidation("eps", fieldSettings)?.required,
      then: Yup.object().shape({
        id: Yup.string().notRequired(),
      }),
      otherwise: Yup.object().shape({
        id: checkFieldValidation("eps", fieldSettings)?.required
          ? Yup.number().required(t("Camporequerido"))
          : Yup.number().notRequired(),
      }),
    }),
    tipoPlan: Yup.string().when("account", {
      is: (value) =>
        value && value.id === 144 && source === "autoagendamientonuevoeps",
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string(),
    }),
    titular: Yup.object().when("patientRelationship", {
      is: (value) =>
        value &&
        value != "1" &&
        source === "autoagendamientovardi" &&
        checkFieldValidation("patientRelationship", fieldSettings)?.visible,
      then: Yup.object().shape({
        documentNumber: Yup.string().required(t("Camporequerido")),
      }),
      otherwise: Yup.object().shape({
        documentNumber: Yup.string(),
      }),
    }),
    neighborhood: checkFieldValidation("neighborhood", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
  });

  async function fetchNumeroDocumento(documento, idTD, access_token) {
    if (documento && idTD) {
      let result = [];
      const data = {
        documentNumber: documento,
        identityDocumentType: { id: idTD },
      };
      const response = await Post({
        url: PACIENTE_BUSCAR,
        data: data,
        access_token: access_token,
        header: true,
      });
      if (!response.data.state) {
        return result;
      } else {
        result.push(response.data.data);
        return result;
      }
    } else {
      return [];
    }
  }
  //console.log(initialData)
  const handleBlur = (e, error) => {
    if (e.target.value !== "" && error === undefined) {
      setLoadPaciente(true);
      try {
        async function fetchTokenExternal() {
          let response = await getTokenExternal({ id: 2 });
          if (response.data.access_token) {
            //checamos el numero de documento
            const resp = await fetchNumeroDocumento(
              e.target.value,
              idTipoDocumento,
              response.data.access_token
            );
            if (resp.length > 0) {
              const findPatient = resp[resp.length - 1];
              //console.log(findPatient)
              let initColombusA = {
                id: "",
                roadType: findPatient.colombusAddress?.roadType?.id ?? "",
                roadType_name:
                  findPatient.colombusAddress?.roadType?.name ?? "",
                streetField1: findPatient.colombusAddress?.streetField1 ?? "",
                streetField2: findPatient.colombusAddress?.streetField2 ?? "",
                streetField3: findPatient.colombusAddress?.streetField3 ?? "",
                propertyNumber:
                  findPatient.colombusAddress?.propertyNumber ?? "",
                propertyType:
                  findPatient.colombusAddress?.propertyType?.id ?? "",
                propertyTypeAdditional:
                  findPatient.colombusAddress?.propertyTypeAdditional?.id ?? "",
                unitNumber: findPatient.colombusAddress?.unitNumber ?? "",
              };
              //console.log(findPatient)
              setInitialData((prev) => ({
                ...prev,
                id: findPatient.id,
                name: findPatient.name.toUpperCase(),
                middleName: findPatient.middleName.toUpperCase() ?? "",
                seccondSurname: findPatient.seccondSurname.toUpperCase() ?? "",
                lastName: findPatient.lastName.toUpperCase() ?? "",
                gender: findPatient.gender ?? "",
                dateOfBirthday: findPatient.dateOfBirthday ?? "",
                nationality: findPatient.nationality,
                phoneNumber: findPatient.phone,
                phoneNumber2: findPatient.phone2,
                email: findPatient.email,
                bloodType: findPatient.bloodType,
                ocupacion: findPatient.ocupacion?.id ?? "",
                ocupacion_name: findPatient.ocupacion?.name ?? "",
                //account: findPatient.account,
                neighborhood: findPatient.neighborhood,
                identityDocumentType:
                  findPatient.identityDocumentType?.id ?? "",
                documentNumber: findPatient.documentNumber,
                country: findPatient.country?.id ?? "",
                country_name: findPatient.country?.name ?? "",
                countryBirth_name: findPatient.countryBirth?.name ?? "",
                state: findPatient.state?.id ?? "",
                state_name: findPatient.state?.name ?? "",
                municipio: findPatient.municipio?.id ?? "",
                municipio_name: findPatient.municipio?.dsMunDel ?? "",
                location: findPatient.localidad?.id ?? "",
                location_name: findPatient.localidad?.name ?? "",
                patientRelationship:
                  findPatient.patientRelationshipDTO?.id ?? "",
                countryBirth: findPatient.countryBirth?.id ?? "",
                colombusAddress: initColombusA,
                roadType_name:
                  findPatient.colombusAddress?.roadType?.name ?? "",
                propertyType_name:
                  findPatient.colombusAddress?.propertyType?.name ?? "",
                propertyTypeAdditional_name:
                  findPatient.colombusAddress?.propertyTypeAdditional?.name ??
                  "",
                identityDocumentTypeModel: findPatient.identityDocumentType,
                eps: findPatient.eps?.id
                  ? {
                      id: findPatient.eps?.id,
                      nombreEps: findPatient.eps?.name,
                    }
                  : { id: "" },
                tipoPlan: "",
              }));
              setDateOfBirthday(
                findPatient.dateOfBirthday
                  ? new Date(moment(findPatient.dateOfBirthday, "DD-MM-YYYY"))
                  : null
              );
              setPhoneNumber(findPatient.phone);
              setPhoneNumber2(findPatient.phone2 ? findPatient.phone2 : "57");
              setGender(findPatient?.gender ?? "");
              setTipoSangre(findPatient?.bloodType ?? "");
              setPaisNacimientoDefault({
                value: findPatient.countryBirth?.id ?? "",
                label: findPatient.countryBirth?.name,
              });
              setPaisDefault({
                value: findPatient.country?.id ?? "",
                label: findPatient.country?.name,
              });
              setIdCountry(findPatient.country?.id ?? "");
              setEstadoDefault({
                value: findPatient.state?.id ?? "",
                label: findPatient.state?.name,
              });
              setIdEstado(findPatient.state?.id ?? "");
              setMunicipioDefault({
                value: findPatient.municipio?.id ?? "",
                label: findPatient.municipio?.dsMunDel,
              });
              setLocationDefault({
                value: findPatient.localidad?.id ?? "",
                label: findPatient.localidad?.name,
              });
              setOcupacionDefault({
                value: findPatient.ocupacion?.id ?? "",
                label: findPatient.ocupacion?.name,
              });
              setRoadTypesDefault({
                value: findPatient.colombusAddress?.roadType?.id ?? "",
                label: findPatient.colombusAddress?.roadType?.name,
              });
              setPropertyTypesDefault({
                value: findPatient.colombusAddress?.propertyType?.id ?? "",
                label: findPatient.colombusAddress?.propertyType?.name,
              });
              setPropertyTypesAdicionalDefault({
                value:
                  findPatient.colombusAddress?.propertyTypeAdditional?.id ?? "",
                label:
                  findPatient.colombusAddress?.propertyTypeAdditional?.name,
              });
              setEpsDefault(
                findPatient.eps
                  ? {
                      value: findPatient.eps?.id ?? "",
                      label: findPatient.eps?.name,
                    }
                  : null
              );
              if (findPatient.eps?.name === "NUEVA EPS") setIsEpsDefault(true);
              setModalEncontro(true);
            } else {
              setInitialData((prev) => ({
                ...prev,
                id: "",
                name: "",
                middleName: "",
                seccondSurname: "",
                lastName: "",
                gender: "",
                dateOfBirthday: "",
                nationality: "",
                phoneNumber: "",
                phoneNumber2: "",
                email: "",
                identityDocumentType: tipoDocumentoOpt.filter(
                  (e) => e.id === idTipoDocumento
                )[0].id,
                identityDocumentTypeModel: tipoDocumentoOpt.filter(
                  (e) => e.id === idTipoDocumento
                )[0],
                documentNumber: e.target.value,
                bloodType: "",
                ocupacion: "",
                ocupacion_name: "",
                account: initialData.account,
                neighborhood: "",
                country: "",
                country_name: "",
                countryBirth_name: "",
                state: "",
                state_name: "",
                municipio: "",
                municipio_name: "",
                location: "",
                location_name: "",
                patientRelationship: "",
                countryBirth: "",
                colombusAddress: {
                  id: "",
                  roadType: "",
                  streetField1: "",
                  streetField2: "",
                  streetField3: "",
                  propertyNumber: "",
                  propertyType: "",
                  propertyTypeAdditional: "",
                  unitNumber: "",
                },
                roadType_name: "",
                eps: {
                  id: "",
                  nombreEps: "",
                  codigo: "",
                },
                tipoPlan: "",
              }));
              setDateOfBirthday(null);
              setPhoneNumber("57");
              setPhoneNumber2("57");
              setGender("");
              setTipoSangre("");
              setPaisNacimientoDefault(null);
              setPaisDefault(null);
              setEstadoDefault(null);
              setMunicipioDefault(null);
              setLocationDefault(null);
              setOcupacionDefault(null);
              setRoadTypesDefault(null);
              setPropertyTypesDefault(null);
              setPropertyTypesAdicionalDefault(null);
              setEpsDefault(null);
            }
            setLoadPaciente(false);
            setDisabledInputs(false);
          }
        }
        fetchTokenExternal();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const resetAllForm = () => {
    setInitialData(stateByDefault);
    setDateOfBirthday(null);
    setPhoneNumber("57");
    setPhoneNumber2("57");
    setGender("");
    setTipoSangre("");
    setPaisNacimientoDefault(null);
    setPaisDefault(null);
    setEstadoDefault(null);
    setMunicipioDefault(null);
    setRoadTypesDefault(null);
    setPropertyTypesDefault(null);
    setPropertyTypesAdicionalDefault(null);
  };

  //solo pasa en vardi
  const [tipoPaciente, setTipoPaciente] = useState("");
  const [modalTitular, setModalTitular] = useState(false);
  const [tipoDocModal, setTipoDocModal] = useState("");
  const [documentModal, setDocumentModal] = useState("");
  useEffect(() => {
    if (source === "autoagendamientovardi" && tipoPaciente) {
      let type = tipoPacientes.filter(
        (item) =>
          item.name.toLowerCase() === "titular" &&
          item.id === parseInt(tipoPaciente)
      );
      if (type.length === 0) {
        setModalTitular(true);
      }
    }
  }, [tipoPaciente, source]);

  const handleCloseTitular = () => {
    setModalTitular(false);
  };
  //console.log(initialData)
  const [errorForm, setErrorForm] = useState(false);
  const [copyValues, setCopyValues] = useState(null);
  const validarDocumento = () => {
    if (documentModal && tipoDocModal) {
      setIsBusandoPaciente(true);
      setErrorForm(false);
      try {
        async function fetchTokenExternal() {
          let response = await getTokenExternal({ id: 2 });
          if (response.data.access_token) {
            const resp = await fetchNumeroDocumento(
              documentModal,
              tipoDocModal,
              response.data.access_token
            );
            if (resp.length > 0) {
              setInitialData((prev) => ({
                ...copyValues,
                titular: {
                  documentNumber: resp[0].documentNumber,
                  identityDocumentType: resp[0].identityDocumentType,
                },
              }));
            }
          }
          setIsBusandoPaciente(false);
          setModalTitular(false);
        }
        fetchTokenExternal();
      } catch (error) {
        setIsBusandoPaciente(false);
        console.log(error);
      }
    } else {
      setErrorForm(true);
    }
  };
  //console.log(initialData)
  //console.log(source)
  return (
    <Formik
      initialValues={initialData}
      validationSchema={shemaValidateStepOne}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, errors, handleSubmit, setFieldValue, setFieldError }) => (
        <Form onSubmit={handleSubmit}>
          {loadPaciente && <LoadingList texto={"Buscando paciente"} />}
          <Card className="mb-3">
            {configuration?.informationPatientStep1 && (
              <Card.Header className="text-center bg-primary text-white">
                <h5 className="m-0 text">{t("informacion_pacientes")}</h5>
                <p className="m-0 font-size-08rem text">
                  {configuration?.informationPatientStep1}
                </p>
              </Card.Header>
            )}

            <Card.Body>
              <Row className="mb-md-4">
                <Col className="text-right">
                  <Button type="submit" variant="primary" className="btn1">
                    {t("siguiente")}
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {t("tipo_documento")}{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      as="select"
                      className={`form-control input-form ${
                        errors.identityDocumentType && "error"
                      }`}
                      name="identityDocumentType"
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setIdTipoDocumento(parseInt(e.target.value));
                          setFieldValue(
                            "identityDocumentType",
                            parseInt(e.target.value)
                          );
                          setFieldValue(
                            "identityDocumentTypeModel",
                            tipoDocumentoOpt.filter(
                              (el) => el.id === parseInt(e.target.value)
                            )[0]
                          );
                          let aux = tipoDocumentoOpt.filter(
                            (el) => el.id === parseInt(e.target.value)
                          )[0];
                          setDisabledDocument(false);
                          setHasLength(getLengthDN(aux.code));
                        } else {
                          setIdTipoDocumento(null);
                          setFieldValue("identityDocumentType", e.target.value);
                          setFieldValue("identityDocumentTypeModel", "");
                          setDisabledDocument(true);
                          setDisabledInputs(true);
                          //reset all form
                          resetAllForm();
                        }
                      }}
                    >
                      <option value="">{t("Seleccionar")}</option>
                      {tipoDocumentoOpt.map((item, i) => (
                        <option
                          value={item.id}
                          key={i}
                        >{`${item.code} : ${item.name}`}</option>
                      ))}
                    </Field>
                    {errors.identityDocumentType && (
                      <div className="invalid-feedback d-block">
                        {errors.identityDocumentType}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {t("documento_identidad")}{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    {notEdit ? (
                      <div className="form-control input-form">
                        {values.documentNumber}
                      </div>
                    ) : (
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.documentNumber && "error"
                        }`}
                        name="documentNumber"
                        onBlur={(e) => handleBlur(e, errors.documentNumber)}
                        disabled={disabledDocument}
                      />
                    )}
                    {errors.documentNumber && (
                      <div className="invalid-feedback d-block">
                        {errors.documentNumber}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                {checkFieldValidation("patientRelationship", fieldSettings)
                  ?.visible && (
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Tipo paciente
                        {checkFieldValidation(
                          "patientRelationship",
                          fieldSettings
                        )?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Field
                        as="select"
                        className={`form-control input-form ${
                          errors.patientRelationship && "error"
                        }`}
                        name="patientRelationship"
                        disabled={disabledInputs}
                        onChange={(e) => {
                          if (e.target.value) {
                            setFieldValue(
                              "patientRelationship",
                              e.target.value
                            );
                          } else {
                            setFieldValue("patientRelationship", "");
                          }
                          setTipoPaciente(e.target.value);
                          setCopyValues({
                            ...values,
                            patientRelationship: e.target.value,
                          });
                        }}
                      >
                        <option value="">Seleccionar</option>
                        {tipoPacientes.map((item, i) => (
                          <option key={i} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Field>
                      {errors.patientRelationship && (
                        <div className="invalid-feedback d-block">
                          {errors.patientRelationship}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                {values.patientRelationship &&
                  values.patientRelationship != "1" &&
                  source === "autoagendamientovardi" && (
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Número de documento del titular
                        </Form.Label>
                        <Field
                          className={`form-control input-form ${
                            errors.titular?.documentNumber && "error"
                          }`}
                          name="titular.documentNumber"
                        />
                        {errors.titular?.documentNumber && (
                          <div className="invalid-feedback d-block">
                            {errors.titular?.documentNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  )}
                {checkFieldValidation("ocupacion", fieldSettings)?.visible && (
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("ocupacion")}
                        {checkFieldValidation("ocupacion", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.ocupacion && "error"}`}
                        options={ocupacionOpt}
                        defaultValue={ocupacionDefault}
                        value={ocupacionDefault}
                        onChange={(value) => {
                          //console.log(value)
                          setOcupacionDefault(value);
                          setFieldValue("ocupacion", value.value);
                          setFieldValue("ocupacion_name", value.label);
                        }}
                        placeholder="Escoger opción"
                        isDisabled={disabledInputs}
                      />
                      {errors.ocupacion && (
                        <div className="invalid-feedback d-block">
                          {errors.ocupacion}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Row>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {t("Nombre")} <span className="text-danger">*</span>
                    </Form.Label>
                    {notEdit ? (
                      <div className="form-control input-form">
                        {values.name}
                      </div>
                    ) : (
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase ${
                          errors.name && "error"
                        }`}
                        name="name"
                        onChange={(e) => {
                          setFieldValue("name", e.target.value.toUpperCase());
                        }}
                        disabled={disabledInputs}
                      />
                    )}
                    {errors.name && (
                      <div className="invalid-feedback d-block">
                        {errors.name}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Segundo nombre{" "}
                    </Form.Label>
                    {notEdit ? (
                      <div className="form-control input-form">
                        {values.middleName}
                      </div>
                    ) : (
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase`}
                        name="middleName"
                        onChange={(e) => {
                          setFieldValue(
                            "middleName",
                            e.target.value.toUpperCase()
                          );
                        }}
                        disabled={disabledInputs}
                      />
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Primer apellido <span className="text-danger">*</span>
                    </Form.Label>
                    {notEdit ? (
                      <div className="form-control input-form">
                        {values.lastName}
                      </div>
                    ) : (
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase ${
                          errors.lastName && "error"
                        }`}
                        name="lastName"
                        onChange={(e) => {
                          setFieldValue(
                            "lastName",
                            e.target.value.toUpperCase()
                          );
                        }}
                        disabled={disabledInputs}
                      />
                    )}
                    {errors.lastName && (
                      <div className="invalid-feedback d-block">
                        {errors.lastName}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Segundo apellido
                    </Form.Label>
                    {notEdit ? (
                      <div className="form-control input-form">
                        {values.seccondSurname}
                      </div>
                    ) : (
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase`}
                        name="seccondSurname"
                        onChange={(e) => {
                          setFieldValue(
                            "seccondSurname",
                            e.target.value.toUpperCase()
                          );
                        }}
                        disabled={disabledInputs}
                      />
                    )}
                  </Form.Group>
                </Col>

                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {source && source === "autoagendamientoappallianz"
                        ? t("correo_electronico_cita")
                        : t("Correoelectronico")}{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    {notEdit ? (
                      <div className="form-control input-form">
                        {values.email}
                      </div>
                    ) : (
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.email && "error"
                        }`}
                        name="email"
                        disabled={disabledInputs}
                      />
                    )}
                    {errors.email && (
                      <div className="invalid-feedback d-block">
                        {errors.email}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {t("Telefono")} <span className="text-danger">*</span>
                    </Form.Label>
                    <PhoneInput
                      inputClass={`form-control input-form ${
                        errors.phoneNumber && "error"
                      } w-100`}
                      country={"co"}
                      countryCodeEditable={false}
                      enableSearch={true}
                      preferredCountries={["co", "mx"]}
                      disableSearchIcon={true}
                      localization={es}
                      value={phoneNumber}
                      disabled={disabledInputs}
                      onChange={(phone, country, e, formattedValue) => {
                        //console.log(phone)
                        setPhoneNumber(phone);
                        setFieldValue("phoneNumber", phone);
                        let validNumber = country.format.match(/\./g).length;
                        if (phone.length !== validNumber) {
                          setFieldError("phoneNumber", "Campo inválido");
                        } else if (phone.length === validNumber) {
                          setFieldValue("phoneNumber", phone, true);
                        }
                      }}
                    />
                    {errors.phoneNumber && (
                      <div className="invalid-feedback d-block">
                        {errors.phoneNumber}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Teléfono alterno <span className="text-danger">*</span>
                    </Form.Label>
                    {enableFieldConsulta && values.phoneNumber2 === "" ? (
                      <PhoneInput
                        inputClass={`form-control input-form ${
                          errors.phoneNumber2 && "error"
                        } w-100`}
                        country={"co"}
                        countryCodeEditable={false}
                        enableSearch={true}
                        preferredCountries={["co", "mx"]}
                        disableSearchIcon={true}
                        localization={es}
                        value={phoneNumber2}
                        onChange={(phone, country, e, formattedValue) => {
                          //console.log(phone)
                          setPhoneNumber2(phone);
                          setFieldValue("phoneNumber2", phone);
                          let validNumber = country.format.match(/\./g).length;
                          if (phone.length !== validNumber) {
                            setFieldError("phoneNumber2", "Campo inválido");
                          } else if (phone.length === validNumber) {
                            setFieldValue("phoneNumber2", phone, true);
                          }
                        }}
                      />
                    ) : (
                      <PhoneInput
                        inputClass={`form-control input-form ${
                          errors.phoneNumber2 && "error"
                        } w-100`}
                        country={"co"}
                        countryCodeEditable={false}
                        enableSearch={true}
                        preferredCountries={["co", "mx"]}
                        disableSearchIcon={true}
                        localization={es}
                        value={phoneNumber2}
                        disabled={disabledInputs}
                        onChange={(phone, country, e, formattedValue) => {
                          //console.log(phone)
                          setPhoneNumber2(phone);
                          setFieldValue("phoneNumber2", phone);
                          let validNumber = country.format.match(/\./g).length;
                          if (phone.length !== validNumber) {
                            setFieldError("phoneNumber2", "Campo inválido");
                          } else if (phone.length === validNumber) {
                            setFieldValue("phoneNumber2", phone, true);
                          }
                        }}
                      />
                    )}
                    {errors.phoneNumber2 && (
                      <div className="invalid-feedback d-block">
                        {errors.phoneNumber2}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                {checkFieldValidation("gender", fieldSettings)?.visible && (
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("sexo")}
                        {checkFieldValidation("gender", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      {disabledInputs ? (
                        <ul className="mb-0 list-inline list-form">
                          {[
                            t("Femenino"),
                            t("Masculino"),
                            "No especificado",
                          ].map((item, index) => (
                            <li className={`list-inline-item`} key={index}>
                              <span
                                className="input-radio-custom text-color-input"
                                style={{ backgroundColor: "#e9ecef" }}
                              >
                                {item}
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <ul className="mb-0 list-inline list-form">
                          <li
                            className={`${
                              gender === "Female" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setGender("Female");
                              setFieldValue("gender", "Female");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              {t("Femenino")}
                            </span>
                          </li>
                          <li
                            className={`${
                              gender === "Male" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setGender("Male");
                              setFieldValue("gender", "Male");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              {t("Masculino")}
                            </span>
                          </li>
                          <li
                            className={`${
                              gender === "NotSpecified" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setGender("NotSpecified");
                              setFieldValue("gender", "NotSpecified");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              No especificado
                            </span>
                          </li>
                        </ul>
                      )}
                      {errors.gender && (
                        <div className="invalid-feedback d-block">
                          {errors.gender}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary d-block">
                      {t("fecha_nacimiento")}{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePicker
                      className={`form-control input-form w-100 ${
                        errors.dateOfBirthday && "error"
                      }`}
                      selected={dateOfBirthday}
                      dateFormat="dd-MM-yyyy"
                      maxDate={new Date()}
                      disabled={disabledInputs}
                      onChange={(date) => {
                        if (date === null) {
                          setDateOfBirthday(null);
                          setFieldValue("dateOfBirthday", "");
                        } else {
                          setDateOfBirthday(date);
                          setFieldValue("dateOfBirthday", date);
                        }
                      }}
                    />
                    {errors.dateOfBirthday && (
                      <div className="invalid-feedback d-block">
                        {errors.dateOfBirthday}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                {values.account.id === 144 &&
                  source === "autoagendamientonuevoeps" && (
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Tipo de plan <span className="text-danger">*</span>
                        </Form.Label>
                        <Field
                          as="select"
                          name="tipoPlan"
                          className={`form-control input-form ${
                            errors.tipoPlan && "error"
                          }`}
                          disabled={disabledInputs}
                        >
                          <option value="">Seleccionar</option>
                          <option value="PLUS">Plus</option>
                          <option value="INTEGRAL">Integral</option>
                        </Field>
                        {errors.tipoPlan && (
                          <div className="invalid-feedback d-block">
                            {errors.tipoPlan}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  )}
                {!isEpsDefault &&
                  checkFieldValidation("eps", fieldSettings)?.visible && (
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Entidad Promotora de Salud (EPS)
                          {checkFieldValidation("eps", fieldSettings)
                            ?.required && (
                            <span className="text-danger">*</span>
                          )}
                        </Form.Label>
                        <Select
                          className={`input-form ${errors.eps && "error"}`}
                          options={epsOpt}
                          defaultValue={epsDefault}
                          value={epsDefault}
                          onChange={(value) => {
                            //console.log(value)
                            setEpsDefault(value);
                            setFieldValue("eps.id", value.value);
                            setFieldValue("eps.nombreEps", value.label);
                          }}
                          placeholder="Escoger opción"
                          isDisabled={
                            enableFieldConsulta ? false : disabledInputs
                          }
                        />
                        {errors.eps?.id && (
                          <div className="invalid-feedback d-block">
                            {errors.eps?.id}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  )}

                {checkFieldValidation("bloodType", fieldSettings)?.visible && (
                  <Col xs="12" md="5">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("Tiposangre")}
                        {checkFieldValidation("bloodType", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      {disabledInputs ? (
                        <ul className="mb-0 list-inline list-form">
                          {[
                            "O-",
                            "O+",
                            "A-",
                            "A+",
                            "AB-",
                            "AB+",
                            "B+",
                            "B-",
                            "Desconocido",
                          ].map((item, index) => (
                            <li className={`list-inline-item`} key={index}>
                              <span
                                className="input-radio-custom text-color-input"
                                style={{ backgroundColor: "#e9ecef" }}
                              >
                                {item}
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <ul className="mb-0 list-inline list-form">
                          <li
                            className={`${
                              tipoSangre === "O-" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("O-");
                              setFieldValue("bloodType", "O-");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              O-
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "O+" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("O+");
                              setFieldValue("bloodType", "O+");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              O+
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "A-" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("A-");
                              setFieldValue("bloodType", "A-");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              A-
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "A+" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("A+");
                              setFieldValue("bloodType", "A+");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              A+
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "AB-" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("AB-");
                              setFieldValue("bloodType", "AB-");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              AB-
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "AB+" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("AB+");
                              setFieldValue("bloodType", "AB+");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              AB+
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "B+" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("B+");
                              setFieldValue("bloodType", "B+");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              B+
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "B-" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("B-");
                              setFieldValue("bloodType", "B-");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              B-
                            </span>
                          </li>
                          <li
                            className={`${
                              tipoSangre === "desconocido" && "active"
                            } list-inline-item cursor-pointer`}
                            onClick={(e) => {
                              setTipoSangre("desconocido");
                              setFieldValue("bloodType", "desconocido");
                            }}
                          >
                            <span className="input-radio-custom text-color-input">
                              {t("Desconocido")}
                            </span>
                          </li>
                        </ul>
                      )}
                      {errors.bloodType && (
                        <div className="invalid-feedback d-block">
                          {errors.bloodType}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                {checkFieldValidation("nationality", fieldSettings)
                  ?.visible && (
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("Nacionalidad")}
                        {checkFieldValidation("nationality", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <div className="mt-3">
                        <label className="mr-5 text-color-input">
                          {t("colombiana")}
                          <Field
                            type="radio"
                            name="nationality"
                            value="Colombiana"
                            className="ml-3 radio-form"
                            onChange={(e) => {
                              setFieldValue("nationality", "Colombiana");
                              let p = countryOpt.filter(
                                (el) => el.label.toLowerCase() === "colombia"
                              );
                              if (p.length > 0) {
                                setFieldValue("country", p[0].value);
                                setFieldValue("country_name", p[0].label);
                                setPaisDefault({
                                  label: p[0].label,
                                  value: p[0].value,
                                });
                                setIdCountry(p[0].value);

                                setFieldValue("countryBirth", p[0].value);
                                setFieldValue("countryBirth_name", p[0].label);
                                setPaisNacimientoDefault({
                                  label: p[0].label,
                                  value: p[0].value,
                                });
                              }
                            }}
                            disabled={disabledInputs}
                          />
                        </label>
                        <label className="mr-5 text-color-input">
                          {t("Extranjera")}
                          <Field
                            type="radio"
                            name="nationality"
                            value="Extranjera"
                            className="ml-3 radio-form"
                            disabled={disabledInputs}
                          />
                        </label>
                      </div>
                      {errors.nationality && (
                        <div className="invalid-feedback d-block">
                          {errors.nationality}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}

                {checkFieldValidation("countryBirth", fieldSettings)
                  ?.visible && (
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        País de nacimiento
                        {checkFieldValidation("countryBirth", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Select
                        className={`input-form ${
                          errors.countryBirth && "error"
                        }`}
                        options={countryBirthOpt}
                        defaultValue={paisNacimientoDefault}
                        value={paisNacimientoDefault}
                        onChange={(value) => {
                          //console.log(value)
                          setPaisNacimientoDefault(value);
                          setFieldValue("countryBirth", value.value);
                          setFieldValue("countryBirth_name", value.label);
                        }}
                        placeholder="Escoger opción"
                        isDisabled={
                          values.nationality === "Colombiana" || disabledInputs
                        }
                      />
                      {errors.countryBirth && (
                        <div className="invalid-feedback d-block">
                          {errors.countryBirth}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                {checkFieldValidation("country", fieldSettings)?.visible && (
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        País de residencia
                        {checkFieldValidation("country", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.country && "error"}`}
                        options={countryOpt}
                        defaultValue={paisDefault}
                        value={paisDefault}
                        onChange={(value) => {
                          //console.log(e)
                          setPaisDefault(value);
                          setFieldValue("country", value.value);
                          setFieldValue("country_name", value.label);
                          setMunicipioOpt([]);
                          setFieldValue("municipio", "");
                          setFieldValue("municipio_name", "");
                          setMunicipioDefault(null);
                          setFieldValue("state", "");
                          setFieldValue("state_name", "");
                          setEstadoDefault(null);
                          setIdCountry(value.value);
                        }}
                        placeholder="Escoger opción"
                        isDisabled={disabledInputs}
                      />
                      {errors.country && (
                        <div className="invalid-feedback d-block">
                          {errors.country}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {t("departamento")}
                    </Form.Label>
                    <Select
                      className={`input-form ${errors.state && "error"}`}
                      options={estadoOpt}
                      defaultValue={estadoDefault}
                      value={estadoDefault}
                      onChange={(value) => {
                        //console.log(e)
                        setEstadoDefault(value);
                        setFieldValue("state", value.value);
                        setFieldValue("state_name", value.label);
                        setFieldValue("municipio", "");
                        setFieldValue("municipio_name", "");
                        setFieldValue("location", "");
                        setMunicipioDefault(null);
                        setLocationDefault(null);
                        setMunicipioOpt([]);
                        setIdEstado(value.value);
                      }}
                      placeholder="Escoger opción"
                      isDisabled={disabledInputs}
                    />
                    {errors.state && (
                      <div className="invalid-feedback d-block">
                        {errors.state}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Ciudad
                    </Form.Label>
                    <Select
                      className={`input-form ${errors.municipio && "error"}`}
                      options={municipioOpt}
                      defaultValue={municipioDefault}
                      value={municipioDefault}
                      onChange={(value) => {
                        //console.log(value)
                        setMunicipioDefault(value);
                        setFieldValue("municipio", value.value);
                        setFieldValue("municipio_name", value.label);
                        if (value.value !== "2633") {
                          setFieldValue("location", "");
                        }
                      }}
                      placeholder="Escoger opción"
                      isDisabled={disabledInputs}
                    />
                    {errors.municipio && (
                      <div className="invalid-feedback d-block">
                        {errors.municipio}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="3">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Tipo de calle
                    </Form.Label>
                    <Select
                      className={`input-form ${
                        errors.colombusAddress?.roadType && "error"
                      }`}
                      options={roadTypes?.map((e) => ({
                        label: e.name,
                        value: e.id,
                      }))}
                      defaultValue={roadTypesDefault}
                      value={roadTypesDefault}
                      onChange={(e) => {
                        //console.log(e)
                        setRoadTypesDefault(e);
                        setFieldValue("colombusAddress.roadType", e.value);
                        setFieldValue("roadType_name", e.label);
                      }}
                      placeholder="Escoger opción"
                      isDisabled={disabledInputs}
                    />
                    {errors.colombusAddress?.roadType && (
                      <div className="invalid-feedback d-block">
                        {errors.colombusAddress?.roadType}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="2">
                  <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                    No
                  </Form.Label>
                  <Field
                    type="text"
                    className={`form-control input-form ${
                      errors.colombusAddress?.streetField1 && "error"
                    }`}
                    name="colombusAddress.streetField1"
                    disabled={disabledInputs}
                  />
                  {errors.colombusAddress?.streetField1 && (
                    <div className="invalid-feedback d-block">
                      {errors.colombusAddress.streetField1}
                    </div>
                  )}
                </Col>
                <Col xs="12" md="2">
                  <Form.Label className="font-weight-bold-600 text-secondary">
                    Número
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text className="border-right-0 rounded-0 input-group-text-rounded-0">
                      #
                    </InputGroup.Text>
                    <Field
                      type="text"
                      className={`form-control input-form ${
                        errors.colombusAddress?.streetField2 && "error"
                      }`}
                      name="colombusAddress.streetField2"
                      disabled={disabledInputs}
                    />
                  </InputGroup>
                  {errors.colombusAddress?.streetField2 && (
                    <div className="invalid-feedback d-block">
                      {errors.colombusAddress.streetField2}
                    </div>
                  )}
                </Col>
                <Col xs="12" md="2">
                  <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                    Número
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text className="border-right-0 rounded-0 input-group-text-rounded-0">
                      -
                    </InputGroup.Text>
                    <Field
                      type="text"
                      className={`form-control input-form ${
                        errors.colombusAddress?.streetField3 && "error"
                      }`}
                      name="colombusAddress.streetField3"
                      disabled={disabledInputs}
                    />
                  </InputGroup>
                  {errors.colombusAddress?.streetField3 && (
                    <div className="invalid-feedback d-block">
                      {errors.colombusAddress.streetField3}
                    </div>
                  )}
                </Col>
                {municipioDefault?.value === 2633 &&
                  checkFieldValidation("localidad", fieldSettings)?.visible && (
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          {t("localidad")}
                          {checkFieldValidation("localidad", fieldSettings)
                            ?.required && (
                            <span className="text-danger">*</span>
                          )}
                        </Form.Label>
                        <Select
                          className={`input-form ${errors.location && "error"}`}
                          options={localidadesOpt}
                          defaultValue={locationDefault}
                          value={locationDefault}
                          onChange={(value) => {
                            //console.log(value)
                            setLocationDefault(value);
                            setFieldValue("location", value.value);
                            setFieldValue("location_name", value.label);
                          }}
                          placeholder="Escoger opción"
                          isDisabled={disabledInputs}
                        />
                        {errors.location && (
                          <div className="invalid-feedback d-block">
                            {errors.location}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  )}
                {checkFieldValidation("neighborhood", fieldSettings)
                  ?.visible && (
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("barrio")}
                        {checkFieldValidation("neighborhood", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form`}
                        name="neighborhood"
                        disabled={disabledInputs}
                      />
                      {errors.neighborhood && (
                        <div className="invalid-feedback d-block">
                          {errors.neighborhood}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                <Col xs="12" md="12"></Col>

                {checkFieldValidation("propertyType", fieldSettings)
                  ?.visible && (
                  <>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Tipo de Inmueble
                          {checkFieldValidation("propertyType", fieldSettings)
                            ?.required && (
                            <span className="text-danger">*</span>
                          )}
                        </Form.Label>
                        <Select
                          className={`input-form`}
                          options={propertyTypes?.map((e) => ({
                            label: e.name,
                            value: e.id,
                          }))}
                          defaultValue={propertyTypesDefault}
                          value={propertyTypesDefault}
                          onChange={(e) => {
                            //console.log(e)
                            setPropertyTypesDefault(e);
                            setFieldValue(
                              "colombusAddress.propertyType",
                              e.value
                            );
                            setFieldValue("propertyType_name", e.label);
                          }}
                          placeholder="Escoger opción"
                          isDisabled={disabledInputs}
                        />
                        {errors.colombusAddress?.propertyType && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress?.propertyType}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="2">
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {" "}
                        No.
                        {checkFieldValidation("propertyType", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.colombusAddress?.unitNumber && "error"
                        }`}
                        name="colombusAddress.unitNumber"
                        disabled={disabledInputs}
                      />
                      {errors.colombusAddress?.propertyType && (
                        <div className="invalid-feedback d-block">
                          {errors.colombusAddress?.propertyType}
                        </div>
                      )}
                    </Col>
                  </>
                )}
                {checkFieldValidation("propertyTypeAdditional", fieldSettings)
                  ?.visible && (
                  <>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Bloque o Interior
                          {checkFieldValidation(
                            "propertyTypeAdditional",
                            fieldSettings
                          )?.required && <span className="text-danger">*</span>}
                        </Form.Label>
                        <Select
                          className={`input-form`}
                          options={propertyTypes?.map((e) => ({
                            label: e.name,
                            value: e.id,
                          }))}
                          defaultValue={propertyTypesAdicionalDefault}
                          value={propertyTypesAdicionalDefault}
                          onChange={(e) => {
                            //console.log(e)
                            setPropertyTypesAdicionalDefault(e);
                            setFieldValue(
                              "colombusAddress.propertyTypeAdditional",
                              e.value
                            );
                            setFieldValue(
                              "propertyTypeAdditional_name",
                              e.label
                            );
                          }}
                          placeholder="Escoger opción"
                          isDisabled={disabledInputs}
                        />
                        {errors.colombusAddress?.propertyTypeAdditional && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress?.propertyTypeAdditional}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="2">
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        No.
                        {checkFieldValidation(
                          "propertyTypeAdditional",
                          fieldSettings
                        )?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.colombusAddress?.propertyNumber && "error"
                        }`}
                        name="colombusAddress.propertyNumber"
                        disabled={disabledInputs}
                      />
                      {errors.colombusAddress?.propertyTypeAdditional && (
                        <div className="invalid-feedback d-block">
                          {errors.colombusAddress?.propertyTypeAdditional}
                        </div>
                      )}
                    </Col>
                  </>
                )}

                {checkFieldValidation("peso", fieldSettings)?.visible && (
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("peso")} (Kg)
                        {checkFieldValidation("peso", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      {enableFieldConsulta ? (
                        <Field
                          type="number"
                          className={`form-control input-form ${
                            errors.peso && "error"
                          }`}
                          name="peso"
                        />
                      ) : (
                        <Field
                          type="number"
                          className={`form-control input-form ${
                            errors.peso && "error"
                          }`}
                          name="peso"
                          disabled={disabledInputs}
                        />
                      )}
                      {errors.peso && (
                        <div className="invalid-feedback d-block">
                          {errors.peso}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}
                {checkFieldValidation("talla", fieldSettings)?.visible && (
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("talla")} (cm)
                        {checkFieldValidation("talla", fieldSettings)
                          ?.required && <span className="text-danger">*</span>}
                      </Form.Label>
                      {enableFieldConsulta ? (
                        <Field
                          type="number"
                          className={`form-control input-form ${
                            errors.talla && "error"
                          }`}
                          name="talla"
                        />
                      ) : (
                        <Field
                          type="number"
                          className={`form-control input-form ${
                            errors.talla && "error"
                          }`}
                          name="talla"
                          disabled={disabledInputs}
                        />
                      )}
                      {errors.talla && (
                        <div className="invalid-feedback d-block">
                          {errors.talla}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}

                <Col xs="12" md="12">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      {t("motivo_consulta")}{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    {enableFieldConsulta ? (
                      <Field
                        as="textarea"
                        rows="3"
                        className={`form-control input-form ${
                          errors.sintomas && "error"
                        }`}
                        name="sintomas"
                      />
                    ) : (
                      <Field
                        as="textarea"
                        rows="3"
                        className={`form-control input-form ${
                          errors.sintomas && "error"
                        }`}
                        name="sintomas"
                        disabled={disabledInputs}
                      />
                    )}
                    {errors.sintomas && (
                      <div className="invalid-feedback d-block">
                        {errors.sintomas}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col xs="12" md="12">
                  <Form.Group className="text-center">
                    <Field
                      type="checkbox"
                      rows="3"
                      className={`${errors.aceptarTerminos && "error"} mr-2`}
                      name="aceptarTerminos"
                    />
                    <Form.Label
                      className="font-weight-bold-600 text-primary cursor-pointer link"
                      onClick={(e) => setShow(true)}
                    >
                      {t("aceptar_term_cond_legales")}
                    </Form.Label>
                    {errors.aceptarTerminos && (
                      <div className="invalid-feedback d-block">
                        {errors.aceptarTerminos}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="text-right">
                  <Button type="submit" variant="primary" className="btn1">
                    {t("siguiente")}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Modal size="lg" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <h5>{t("aviso_legal_privacidad")}</h5>
            </Modal.Header>
            <Modal.Body>
              <p className="font-size-08rem">
                <label className="d-block text-uppercase">
                  {t("aviso_legal")}
                </label>
                <strong>KOM CARE IPS S.A.S </strong> {t("aviso1")}
                <label className="d-block my-2">{t("aviso2")}</label>
                <label className="d-block">{t("resumen")}</label>
                {t("aviso3")} <br />
                <br />
                {t("aviso4")} <br />
                <br />
                {t("recabando_informacion")}
                <br />
                <strong>– {t("envio_voluntario")} –</strong>
                <br />
                {t("aviso5")}
                <br />
                <br />
                <strong>– {t("galleta_cookie")} –</strong>
                <br />
                {t("aviso6")}
                <br />
                <br />
                {t("aviso7")}.<br />
                <br />
                <strong>– {t("informacion_servidores")} –</strong>
                <br />
                {t("aviso8")}
                <br />
                <br />
                <strong>– {t("uso_informacion")} –</strong>
                <br />
                {t("aviso9")}.<br />
                <br />
                <strong>– {t("comunicacion_interactiva")} –</strong>
                <br />
                {t("aviso10")}
                <br />
                <br />
                {t("aviso11")} <br /> <br />
                <strong>– {t("comunicacion_terceras")} –</strong>
                <br />
                {t("aviso12")}
                <br />
                <br />
                <strong>– {t("control_informacion")} –</strong>
                <br />
                {t("aviso13")}
                <br />
                {t("derecho_autor")}
                <br />© {t("derecho_auto1")}
                <br />
                <br />
                {t("aviso14")}
                <br />
                {t("aviso15")}
                <br />
                <br />
                <strong>– {t("como_contactarnos")} –</strong>
                <br />
                {t("aviso16")}
                <br />
                <br />
                <strong>{t("aviso_privacidad")}</strong>
                <br />
                {t("aviso17")}
                <br />
                <br />
                {t("aviso18")}
                <br />
                {t("aviso19")}
                <br />
                {t("aviso20")}
                <br />
                {t("aviso21")}
                <br />
                {t("aviso22")}
              </p>
            </Modal.Body>
          </Modal>
          <Modal
            show={modalTitular}
            onHide={handleCloseTitular}
            backdrop="static"
            keyboard={false}
          >
            {isBusandoPaciente && <SimpleLoad />}
            <Modal.Header closeButton>
              <h6>Titular</h6>
            </Modal.Header>
            <Modal.Body>
              <Form.Label>
                Por favor indique el número de documento del titular de la
                póliza, con el fin de validar los datos y poder aprobar su cita
              </Form.Label>
              <Row className="mt-3">
                {errorForm && (
                  <Col xs="12" md="12">
                    <Alert variant="danger">
                      Todos los campos son requeridos
                    </Alert>
                  </Col>
                )}
                <Col xs="12" md="12">
                  <Form.Group>
                    <Form.Label>{t("tipo_documento")}</Form.Label>
                    <select
                      className={`form-control input-form`}
                      value={tipoDocModal}
                      onChange={(e) => setTipoDocModal(e.target.value)}
                    >
                      <option value="">{t("Seleccionar")}</option>
                      {tipoDocumentoOpt.map((item, i) => (
                        <option
                          value={item.id}
                          key={i}
                        >{`${item.code} : ${item.name}`}</option>
                      ))}
                    </select>
                  </Form.Group>
                </Col>
                <Col xs="12" md="12">
                  <Form.Group>
                    <Form.Label>{t("documento_identidad")}</Form.Label>
                    <Form.Control
                      className="form-control input-form"
                      value={documentModal}
                      onChange={(e) => setDocumentModal(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs="12" md="12" className="text-right">
                  <Button
                    type="button"
                    variant="primary"
                    className="btn1"
                    onClick={validarDocumento}
                  >
                    Validar
                  </Button>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>

          <ModalText
            show={modalEncontro}
            setShow={setModalEncontro}
            texto={textoEncontro}
          />
        </Form>
      )}
    </Formik>
  );
}

export default withTranslation()(StepOneCLB);
